export default "__VITE_ASSET__Dco1zI$T__"